<script>
  import {mapGetters} from 'vuex'
  export default {
    name: 'safe-zone',
    computed: {
      ...mapGetters(['theme'])
    },
    data() {
      return {
        background: 'linear-gradient(180deg,#7b7b7b,transparent)'
      }
    },
    render(h) {
      return h(
        'div',
        {
          ref: this.ref,
          class: 'fixed inset-x-0 top-0 z-max safe-zone',
          style: {
            background: this.theme === 'light' || this.background === 'rgb(3, 181, 80)' ? this.background : ''
          }
        },
        []
      )
    },
    sockets: {
      speedNetworking(data) {
        if (data.state === 'running' || data.state === 'completed') this.background = 'rgb(3, 181, 80)'
        else this.background = 'linear-gradient(180deg,#7b7b7b,transparent)'
      },
      groupNetworking(data) {
        if (data.state === 'running' || data.state === 'completed') this.background = 'rgb(3, 181, 80)'
        else this.background = 'linear-gradient(180deg,#7b7b7b,transparent)'
      }
    }
  }
</script>
